import { Box, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import BusyIndicator from '~/components/BusyIndicator';
import Header from '~/components/Header';
import ChatDrawer from '~/components/ChatDrawer';
import FeatureToggle, { Features } from '~/components/FeatureToggle';
import ExplorerSidebar from '~/containers/viewer/explorer-sidebar';

export default function ViewerLayout() {
    return (
        <Box display="grid" height="100vh">
            <Header />
            <Box
                display="flex"
                sx={{ overflow: 'hidden', position: 'relative' }}
            >
                <ExplorerSidebar />
                <Box
                    display="grid"
                    flexGrow={1}
                    gridTemplateRows="auto 1fr"
                    overflow="hidden"
                    position="relative"
                >
                    <BusyIndicator />
                    <Toolbar variant="dense" />
                    <Outlet />
                </Box>
                <FeatureToggle feature={Features.AI_CHAT}>
                    <ChatDrawer />
                </FeatureToggle>
            </Box>
        </Box>
    );
}
